import { ResponseData } from "@/typings";
import { TProductResponse } from "@/typings/home";
import { fetchYooFindsApi } from "@/utils/fetch";
import { getUri } from "@/utils/url";
import { GetFetchProductListParams } from "./interface";
import { omit } from "lodash";
export async function fetchHolidayProductList(
  params: GetFetchProductListParams
) {
  return await fetchYooFindsApi<ResponseData<TProductResponse>>(
    getUri(
      `api/activity-zone/${params.holidayType}`,
      omit(params, ["holidayType"])
    )
  );
}
